import React, { useContext, useEffect, useState } from "react";
import "../firebase";
import {
    getAuth,
    createUserWithEmailAndPassword, 
    updateProfile, signInWithEmailAndPassword,
    signOut,
    onAuthStateChanged} from "firebase/auth";

const AuthContext = React.createContext();


export function useAuth(){
    //that's a cutom hook for making the useContext() easier
    return useContext(AuthContext);
}

export function AuthProvider({children}){
    const [loading, setLoading] = useState(true);
    const [currentUser, setCurrentUse] = useState(null)

    useEffect(() =>{
        const auth = getAuth();
        const unsubscribe =  onAuthStateChanged(auth, (user) => {
            setCurrentUse(user);
            setLoading(false);
        });

        return unsubscribe;
    }, [])

    //signup function
    async function signup(email, password, username){
        const auth = getAuth();
        await createUserWithEmailAndPassword(auth,email,password);

        //update profile in firebase
        await updateProfile(auth.currentUser, {
            displayName: username
        })

        const user = auth.currentUser;
        setCurrentUse({
            ...user,
        })
    }

    //login function
    function login(email,password){
        const auth = getAuth();
        return signInWithEmailAndPassword(auth,email,password);
    }

    //logout function
    function logout(){
        const auth = getAuth();
        return signOut(auth);
    }

    const value = {
        currentUser,
        signup,
        login,
        logout,
    }

    return(
        <AuthContext.Provider value={value}>
            {!loading && children}
        </AuthContext.Provider>
    )
}